/*
 * Copyright (c) 2022. American Express Company
 */

// external
import React, { Component, ReactComponentElement } from 'react';

// models and services
import LiteralsService from '../../../services/literals/LiteralsService';
import { PRODUCT_NAME } from 'src/utils/constants';

// components
import Anchor from 'src/components/atomic/atoms/anchor/Anchor';
import Typography from '../../../components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';

// local
import DisclosuresViewModel from 'src/types/view-models/disclosures.view.model';
import './disclosures.scss';

export default class Disclosures extends Component<DisclosuresViewModel> {
    public override render(): ReactComponentElement<any> {
        return (
            <div className="disclosures">
                {this.props.withInvesting && (
                    <Typography variant={TypographyVariants.LEGAL_PRIMARY} className="textDefault block">
                        {LiteralsService.getLiteral('Disclosures.investing')}
                    </Typography>
                )}

                {this.props.withProjections && (
                    <Typography variant={TypographyVariants.LEGAL_PRIMARY} className="textDefault block">
                        {LiteralsService.getLiteral('Disclosures.projections', [PRODUCT_NAME])}
                    </Typography>
                )}

                <Typography variant={TypographyVariants.LEGAL_PRIMARY} className="textDefault block">
                    {LiteralsService.getLiteral('Disclosures.allUsers[0]')}{' '}
                    <Anchor
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.americanexpress.com/us/privacy-center/?inav=footer_privacy_statement"
                    >
                        {LiteralsService.getLiteral('Disclosures.anchorText.privacyStatement')}
                    </Anchor>{' '}
                    {LiteralsService.getLiteral('Disclosures.allUsers[1]')}{' '}
                    <Anchor
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.americanexpress.com/us/legal-disclosures/website-rules-and-regulations.html?inav=footer_Terms_of_Use"
                    >
                        {LiteralsService.getLiteral('Disclosures.anchorText.termsOfService')}
                    </Anchor>
                    {LiteralsService.getLiteral('Disclosures.allUsers[2]')}
                </Typography>

                <Anchor
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.americanexpress.com/us/security-center/?inav=footer_fraud_protection_center"
                    typographyProps={{ variant: TypographyVariants.LEGAL_PRIMARY, className: 'textDefault block' }}
                >
                    {LiteralsService.getLiteral('Disclosures.anchorText.securityCenter')}
                </Anchor>

                <Typography variant={TypographyVariants.LEGAL_PRIMARY} className="textDefault block">
                    {LiteralsService.getLiteral('Disclosures.allRightsReserved')}
                </Typography>
            </div>
        );
    }
}
